__turbopack_context__.v({
  "container": "ITNCoverageGraph-module-scss-module__MlVXIa__container",
});
